/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A write-only HTTP header configured on an OTEL destination.
 */
export type OtelDestinationHeader = {
  /**
   * Whether a non-empty encrypted value is stored for this header.
   */
  hasValue: boolean;
  /**
   * Header name.
   */
  name: string;
};

/** @internal */
export const OtelDestinationHeader$inboundSchema: z.ZodMiniType<
  OtelDestinationHeader,
  unknown
> = z.pipe(
  z.object({
    has_value: z.boolean(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "has_value": "hasValue",
    });
  }),
);

export function otelDestinationHeaderFromJSON(
  jsonString: string,
): SafeParseResult<OtelDestinationHeader, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OtelDestinationHeader$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OtelDestinationHeader' from JSON`,
  );
}
